function createNode(name, style) {
  name = name || 'div';
  var node = document.createElement(name);
  var styleString = '';
  for (var key in style) {
    if (style.hasOwnProperty(key)) {
      styleString += key + ':' + style[key] + ';'
    }
  }
  node.setAttribute('style', styleString);
  return node;
}

var toast = function (text, delay, zIndex) {
  delay = delay || 1500;
  zIndex = zIndex || 1000;
  var styleOverlay = {
    position: 'fixed',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    background: 'rgba(0,0,0,.5)',
    'z-index': zIndex
  };

  var styleLabel = {
    position: 'fixed',
    top: '50%',
    left: '50%',
    'min-width': '100px',
    'max-width': '200px',
    'line-height': '1.5',
    padding: '10px',
    'border-radius': '5px',
    background: '#000',
    color: '#fff',
    'text-align': 'center',
    'font-size': '14px',
    'word-break': 'break-all',
    'box-sizing': 'border-box',
    '-webkit-transform': 'translate(-50%, -50%)',
    'transform': 'translate(-50%, -50%)',
    'z-index': zIndex + 1
  };

  var nodeOverlay = createNode('div', styleOverlay);
  document.body.appendChild(nodeOverlay);

  var nodeLabel =createNode('div', styleLabel);
  nodeLabel.innerHTML = text;
  document.body.appendChild(nodeLabel);

  var timeout = setTimeout(function () {
    remove();
  }, delay);

  nodeOverlay.addEventListener('touchstart', function (e) {
    remove();
    clearTimeout(timeout);
  });

  function remove() {
    nodeOverlay && document.body.removeChild(nodeOverlay);
    nodeLabel && document.body.removeChild(nodeLabel);
    nodeOverlay = null;
    nodeLabel = null;
  }
};

module.exports = toast;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@gfe/app-common-toast/src/index.js
// module id = FLx6
// module chunks = 0